// Login identifiers are compared case-insensitively; the login lock and the trusted-device storage key both use this form.
export const normalizeIdentifier = (value) => (value || '').toString().trim().toLowerCase();
